module.exports = __webpack_public_path__ + "99781e0b8f8f55660f9871580894bbdc.svg";